<div class="mb-2 border-grey-500 border-[1px] rounded-md p-3">
  <div class="flex justify-between">
    <div class="flex-col flex">
      <div class="flex items-baseline">
        <p class="font-bold">{{task.AuditName}} </p><span class="text-lg"> &#00;&#64;&#00; </span>
        <p class="font-bold text-green-700">{{task.Location.LocationName}}</p>
      </div>

      <p>{{frequencyString()}}</p>
      <div class="mt-2">
        <p>Due: {{periodEndString()}}</p>
        @if (task.FrequencyMultiplier>1) {
          <p>{{task.TotalCompletedInPeriod}} out of
          {{task.FrequencyMultiplier}} completed in period.</p>
        }
        <p>Last Completed: {{lastCompleted()}}</p>

      </div>
    </div>
    @if (!showAuditStartOptions) {
      <div>
        @if (task.CompletedInPeriod) {
          <span class="material-symbols-outlined text-grey-900  pr-2 text-2xl"
          >assignment_turned_in</span>
        }
        @if (!task.CompletedInPeriod) {
          <span (click)="checkExistingAudits()"
          class="material-symbols-outlined cursor-pointer pr-2 text-green-400 text-2xl"> assignment_add</span>
        }
      </div>
    }
    @if (showAuditStartOptions) {
      <div>
        <span class="material-symbols-outlined  cursor-pointer text-grey-900  pr-2 text-2xl "
        (click)="collapseAuditStartOptions()">keyboard_arrow_up</span>
      </div>
    }

  </div>
  @if (showAuditStartOptions) {
    <div class="p-4">
      @if (LocalAudits.length>0) {
        <div>
          <h5>Current {{ 'audit' | customerTerm:true }}</h5>
          <table class=" table-auto bg-standardwhite p-2 mt-1 ">
            <tbody>
              @for (a of LocalAudits; track a) {
                <tr>
                  <td class="p-1">
                    {{humaniseDate(a.FlattenedQuestions[0].AuditCompletionInfo.StartedDate)}}@if (getReferenceQuestion(a.FlattenedQuestions[0]).length>0) {
                    <span> &#40;{{getReferenceQuestion(a.FlattenedQuestions[0])}}&#41;</span>
                  }
                </td>
                <td (click)="continueAudit(a)" class="underline hover:cursor-pointer hover:text-green-700">Continue ></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <div class="mt-3">
      <button class="btn-primary-full" (click)="startNewAudit()" [disabled]="disableStart">@if (disableStart) {
        <span>Loading {{ 'audit' | customerTerm }}...</span>
        }@if (!disableStart) {
        <span>Start {{ 'audit' | customerTerm }}</span>
      }</button>
    </div>
  </div>
}
</div>
